<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path
        d="M884.9 607.2c1.4-13 2-26.2 2-39.5 0-50.6-9.9-99.6-29.5-145.8-18.9-44.6-45.9-84.7-80.3-119.1-32.3-32.3-69.5-58-110.8-76.7-5.2-80.5-72.3-144.4-154-144.4s-148.9 63.9-154 144.4c-41.3 18.7-78.6 44.4-110.8 76.7-34.4 34.4-61.4 74.5-80.3 119.1-19.5 46.2-29.4 95.3-29.4 145.8 0 13.1.7 26.2 2 39.1C98.9 634.6 72 681.4 72 734.5c0 85.1 69.2 154.4 154.4 154.4 24.6 0 47.8-5.8 68.5-16 22.3 15.9 46.2 29.3 71.7 40.1 46.2 19.5 95.3 29.5 145.8 29.5s99.6-9.9 145.8-29.5c25.3-10.7 49.2-24 71.4-39.9 20.5 10.1 43.7 15.9 68.1 15.9 85.1 0 154.4-69.2 154.4-154.4-.1-52.9-26.7-99.6-67.2-127.4zM512.3 146.6c37.4 0 69.5 23.1 82.9 55.7 4.3 10.4 6.6 21.8 6.6 33.8 0 11.7-2.3 22.9-6.4 33.2-13.2 33-45.5 56.3-83.1 56.3s-69.9-23.4-83.1-56.3c-4.1-10.3-6.4-21.5-6.4-33.2 0-12 2.4-23.4 6.6-33.8 13.4-32.7 45.5-55.7 82.9-55.7zm-274 676.6c-3.9.5-7.9.8-12 .8-49.4 0-89.5-40.1-89.5-89.5 0-20.2 6.8-39 18.2-54 13.7-18.1 34.2-30.9 57.6-34.5 4.5-.7 9.1-1.1 13.8-1.1 49.4 0 89.5 40.2 89.5 89.5 0 20.9-7.2 40.1-19.2 55.4-14.1 17.8-34.8 30.2-58.4 33.4zm274 54.3c-60.5 0-117-17.4-164.7-47.5 20.7-26.3 33.1-59.5 33.1-95.5 0-85.1-69.2-154.4-154.4-154.4-8 0-15.8.6-23.5 1.8-.2-4.7-.3-9.4-.3-14.2 0-119.1 67.5-222.7 166.3-274.5 22.8 56.9 78.5 97.2 143.4 97.2s120.7-40.3 143.4-97.2C754.4 345 822 448.6 822 567.7c0 4.8-.1 9.6-.3 14.3-7.9-1.2-15.9-1.9-24.1-1.9-85.1 0-154.4 69.2-154.4 154.4 0 36.1 12.5 69.4 33.4 95.7-47.6 29.9-104 47.3-164.3 47.3zM797.6 824c-3.9 0-7.7-.2-11.4-.7-23.6-3-44.4-15.3-58.6-33.1-12.2-15.3-19.5-34.7-19.5-55.7 0-49.4 40.2-89.5 89.5-89.5 4.9 0 9.7.4 14.4 1.2 23.4 3.8 43.8 16.7 57.4 35 11.1 14.9 17.7 33.4 17.7 53.4.1 49.2-40.1 89.4-89.5 89.4z"
        data-follow-fill="currentColor"
        :fill="_fill"
      />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
